import React, { FunctionComponent, useEffect } from 'react'
import { Alert, Button, Form, Input, notification, Typography } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'

import useLogin, { LoginParamsType } from 'shared/hooks/useLogin'
import logo from 'shared/images/white-logo.png'
import { loginRequest } from 'config/authentication.config'
import getAuthToken from 'shared/utils/getAuthToken'

import styles from './styles.module.less'
import { de, en } from './locales'

type LocationStateType = { from?: string }

interface Props extends RouteComponentProps<never, never, LocationStateType> {}

const Login: FunctionComponent<Props> = ({ history, location }) => {
    const { t, i18n } = useTranslation('LOGIN')
    i18n.addResourceBundle('en-US', 'LOGIN', en)
    i18n.addResourceBundle('de-DE', 'LOGIN', de)

    const [form] = Form.useForm<LoginParamsType>()

    const { instance } = useMsal()
    const isAuthenticated = useIsAuthenticated()

    const {
        user: { isLogged },
        login,
        error,
        isError,
        isLoading,
    } = useLogin()

    function getUrlToRedirect() {
        if (location.state && location.state.from) {
            return location.state.from === '/' ? '/' : location.state.from
        }
        return '/'
    }

    const from = getUrlToRedirect()

    useEffect(() => {
        if (isAuthenticated && isLogged) {
            history.push(from)
        }
    }, [isAuthenticated, isLogged])

    const handleLogin = async () => {
        try {
            await instance.loginPopup(loginRequest)
        } catch (e) {
            console.log(e)
            notification.error({ message: t('something_went_wrong') })
        }
    }

    if (!isLogged && !isLoading && isAuthenticated) {
        console.log('Get token', from, isLogged)

        getAuthToken()
            .then((result) => {
                login({
                    ...result,
                })
            })
            .catch((err) => console.error(err))
    }

    console.log('WELCOME IN AZURE LOGIN PAGE FROM ', from, isLogged)

    return (
        <section className={styles.wrapper}>
            <img alt="logo" className={styles.logo} src={logo} />
            <Form form={form} name="login_form" onFinish={() => handleLogin()}>
                <Typography.Title level={2}>{t('title')}</Typography.Title>
                <Typography.Title level={4}>{t('description')}</Typography.Title>
                <Form.Item>
                    <Button onClick={handleLogin} size="large" type="primary">
                        {t('login')}
                    </Button>
                    {isError && <Alert message={error?.message} showIcon type="error" />}
                </Form.Item>
            </Form>
            <footer className={styles.footer}>&copy; Swiss Insights 2021</footer>
        </section>
    )
}

export default Login
